import * as Yup from "yup";
import { rut } from "../validators";
import { validateDate } from "presentation/common/components/style-guide/form/date-picker/DatePickerContext";

export const validateRequired = (message) =>
  Yup.string()
    .required(message)
    .max(100, "La cantidad máxima de caracteres es 100.");

export const validateEmail = (message) =>
  validateRequired(message).test(
    "email",
    "El correo electrónico no es válido.",
    (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(value?.trim())
  );
export const emailConfirm = (email, confirmEmail, message) =>
  validateEmail(message).test(
    "email-confirm",
    "Los campos de correo no coinciden.",
    () => !confirmEmail || email === confirmEmail
  );
export const distinctEmail = (email, confirmEmail, message) =>
  validateEmail(message).test(
    "distinct-email",
    "Los correos deben ser diferentes.",
    () => email !== confirmEmail
  );
export const validateOptionalEmail = Yup.string()
  .nullable()
  .test(
    "email",
    "El correo electrónico no es válido.",
    (value) =>
      !value ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(value?.trim())
  );
// RUT juridico
export const validateLegalRut = Yup.string()
  .required("El RUT es requerido.")
  .test(
    "legal-rut",
    "El RUT no es válido o no es un RUT de persona jurídica.",
    (value) => rut.checkLegalRut(value)
  );

//RUT natural
export const validateNativeRut = Yup.string()
  .required("El RUT es requerido.")
  .test(
    "native-rut",
    "El RUT no es válido o no es un RUT de persona natural.",
    (value) => rut.checkNativeRut(value)
  );

const FILE_SIZE = 16 * 1024 * 1024;

export const validateFile = (message, extensions = []) =>
  Yup.mixed()
    .required(message)
    .test(
      "fileSize",
      "El archivo excede el tamaño permitido.",
      (value) => value && value.size <= FILE_SIZE
    )
    .test(
      "fileFormat",
      "El archivo no tiene la extensión válida requerida (pdf).",
      (value) => {
        return (
          value && (extensions.length === 0 || extensions.includes(value.type))
        );
      }
    );

export const validateDateHandler = (message, extensions = []) =>
  Yup.mixed()
    .required(message)
    .test("validateDate", "Fecha inválida.", (value) =>
      validateDate(value, "YYYY-MM-DD")
    );

export const validateName = (message) =>
  validateRequired(`El ${message} es requerido.`).matches(
    /^[A-Za-zÀ-ÿ ]*$/,
    `El ${message} no es válido.`
  );

export const validateIfHaveAtLeastLetterRequired = (message) =>
  validateRequired(`La ${message} es requerida.`).test(
    "haveAtLeastHaveLetter",
    `La ${message} no es válida.`,
    (value) => {
      return value?.match(/[A-Za-zÀ-ÿ]+/g)?.length > 0;
    }
  );

export const validateIfHaveAtLeastLetter = (message) =>
  Yup.string()
    .nullable()
    .test("haveAtLeastHaveLetter", `La ${message} no es válida.`, (value) => {
      return !value || value?.match(/[A-Za-zÀ-ÿ]+/g)?.length > 0;
    });

export const validateMaxLength = (maxValue) =>
  Yup.string().max(
    maxValue,
    `La cantidad máxima de caracteres es ${maxValue}.`
  );
export const validateMaxLengthRequired = (maxValue, requiredMessage) =>
  Yup.string()
    .required(requiredMessage)
    .max(maxValue, `La cantidad máxima de caracteres es ${maxValue}.`);
export const validateYear = Yup.number()
  .integer("El año no es válido.")
  .positive("El año no es válido.")
  .typeError("El año no es válido.")
  .required("El año es requerido.")
  .test("len", "El año no es válido.", (value) => {
    return (
      +value &&
      value.toString().length === 4 &&
      value.toString().charAt(0) !== 0
    );
  })
  .max(
    new Date().getFullYear() + 1,
    `El año no es válido, debe ser menor o igual que ${
      new Date().getFullYear() + 1
    }.`
  );
export const validateNumber = Yup.string()
  .required("El monto neto es requerido.")
  .test("isIntegerNumber", "Solo se admiten números enteros.", (value) => {
    return value?.match(/^\+?(0|[1-9]\d*)$/)?.length > 0;
  })
  .test("isPositiveNumber", "Solo se admiten números positivos.", (value) => {
    return +value > 0;
  })
  .max(10, "La cantidad máxima de caracteres es 10.");
